import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";


@Injectable({
    providedIn: 'root'
})

export class GlobalASUForecastReportService
 {
    constructor(protected http: HttpClient) {
    }

    baseurl = environment.apiBaseUrl;

    getGlobalASUForecastReport() {
        return this.http.get<any[]>(this.baseurl + 'GlobalASUForecastReport');
    }
}